import type { MeResponse } from '../utils/api'
import type { TranslationKey } from '../i18n'

type OwnerConsoleSessionIdentity = Pick<MeResponse, 'currentTokenId' | 'tenantMemberId'> | null | undefined

export const getOwnerConsoleSessionIdentityLabelKey = (
  me: OwnerConsoleSessionIdentity
): TranslationKey => (
  me?.currentTokenId
    ? 'ownerConsole.me.currentToken'
    : 'ownerConsole.me.compatibilityMember'
)

export const getOwnerConsoleSessionIdentityValue = (
  me: OwnerConsoleSessionIdentity
): string => (
  me?.currentTokenId ?? me?.tenantMemberId ?? '—'
)